import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { ToastService } from '@siemens/ix-angular/standalone';
import { environment } from '../environments/environment';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

const oauthStorageFactory = () => localStorage;

export const provideTranslation = () => ({
  defaultLanguage: 'en',
  availableLanguages: ['en', 'de'],
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    ToastService,
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideRouter(routes, withComponentInputBinding()),
    importProvidersFrom(
      TranslateModule.forRoot(provideTranslation()),
    ),
    provideOAuthClient({
        resourceServer: {
          allowedUrls: [environment.url],
          sendAccessToken: true
        }
      }),
    { provide: OAuthStorage, useFactory: oauthStorageFactory },
  ],
};
